import { render, staticRenderFns } from "./signUpRecords.vue?vue&type=template&id=d1ac2106&scoped=true&"
import script from "./signUpRecords.vue?vue&type=script&lang=js&"
export * from "./signUpRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ac2106",
  null
  
)

export default component.exports